<template>
    <main class="page custom">

         <section class="white">
            <div class="inner">
                
                <div class="nav">
                    <div>Legal</div>
                    <ul>
                        <li v-for="(page, key) in pages" v-bind:key="key" v-if="defaults.includes(key)">
                            <router-link :to="'/' + key + '/'"><span>{{page.title}}</span></router-link>
                        </li>
                    </ul>
                    <ul class="more">
                        <li v-for="(page, key) in pages" v-bind:key="key" v-if="!defaults.includes(key)">
                            <router-link :to="'/custom/' + key + '/'"><span>{{page.title}}</span></router-link>
                        </li>
                    </ul>
                </div>
                
                <div class="content legal">
                    <h1>{{pages[page_slug].title}}</h1>
                    <div v-html="pages[page_slug].content"></div>
                </div>

            </div>
         </section>

    </main>
</template>

<script>
import legalContent from '@/data/data-legalContent.json';

export default {


    /** ----------------------------------------------------
     * View => Base data
     ----------------------------------------------------- */
    data() {
        
        // data
		return {
            pages: legalContent,
            defaults: ["security", "cookie", "privacy", "terms", "legal"]
        };

    },


    /** ----------------------------------------------------
     * View => Dynamical access to data
     ----------------------------------------------------- */
    computed: {

        page_slug() {
            return ((this.$route.params.id) ? this.$route.params.id : this.$route.name);
        }

    },


    /** ----------------------------------------------------
     * Header
     ----------------------------------------------------- */
    head: {
        // Meta title
        title: function () {
            return {
                inner: this.pages[this.$route.name].title,
                separator: '|',
                complement: 'Sleekplan'
            }
        },
        // Meta tags
        meta: [
            { 
                name: 'description', 
                content: ' ', 
                id: 'desc' 
            },
            { name: 'robots', content: 'noindex' },
        ],
        // Link tags
        link: [
            { 
                rel: 'canonical', 
                href: 'https://sleekplan.com' + location.pathname, 
                id: 'canonical' 
            },
        ]
    }


}
</script>